import { ref, computed } from 'vue'
import {Inertia} from "@inertiajs/inertia";

// User
const notifs = ref([]);

const useNotifs = {
  get : () => {
    const getNotifsQuery = computed(() => notifs.value )
    return getNotifsQuery.value
  },
  push: (notif) => notifs.value.push(notif),
  delete: () => {
    notifs.value.shift();
  }
}
window.addEventListener('popstate', (event) => {
  useNotifs.delete()
});

export { useNotifs }
